import { TextField } from "@mui/material";

import type { CustomRepeatType } from "../hooks/use-number-of-repeats";
import type { TextFieldProps } from "@mui/material";
import type { FC } from "react";

type CustomRepeatEveryProps = Omit<TextFieldProps, "onChange" | "value"> & {
  value: CustomRepeatType["every"];
  onChange: (value: CustomRepeatType["every"]) => void;
};

export const CustomRepeatEvery: FC<CustomRepeatEveryProps> = ({ value, onChange, ...props }) => (
  <TextField
    label="Every"
    type="number"
    value={value}
    onChange={(e) => {
      const val = parseInt(e.target.value, 10);
      onChange(val);
    }}
    sx={{ maxWidth: 90 }}
    {...props}
  />
);
